if (!customElements.get("lion-collection-tabs")) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        images: ".collection-tabs-advanced__image",
        items: ".collection-tabs-advanced__item",
        triggers: "[data-trigger]",
        panels: "[data-panel]",
      };
    }

    init() {
      this.images = this.querySelectorAll(this.selectors.images);
      this.items = this.querySelectorAll(this.selectors.items);
      this.triggers = this.querySelectorAll(this.selectors.triggers);
      this.panels = this.querySelectorAll(this.selectors.panels);

      this.autoplay = this.dataset.autoplay === "true";
      this.autoplayDuration = parseInt(this.dataset.autoplayDuration || "5", 10);
      this.autoplayTimer = null;
      this.tabActiveIndex = 0;
      this.totalTabs = this.items.length;
      this.isPausing = false;

      const triggerBehavior = this.dataset.triggerBehavior || "click";
      this.hoverToOpen =
        triggerBehavior === "hover" && window.matchMedia("(hover: hover)").matches;
    }

    connectedCallback() {
      this.init();

      // Click handlers
      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener("click", () => this.openTab(index));
      });

      // Hover handlers (desktop)
      if (this.hoverToOpen) {
        this.items.forEach((item, index) => {
          item.addEventListener("mouseenter", () => this.openTab(index));
        });
      }

      // Autoplay
      if (this.autoplay) {
        this.style.setProperty("--autoplay-duration", this.autoplayDuration + "s");
        this.initAutoplay();

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.isPausing = false;
              this.initAutoplay();
            } else {
              this.isPausing = true;
              clearTimeout(this.autoplayTimer);
            }
          });
        });
        this.observer.observe(this);
      }
    }

    openTab(index) {
      if (index < 0 || index >= this.totalTabs) return;
      this.tabActiveIndex = index;

      // Update images
      this.images.forEach((img, i) => {
        if (i === index) {
          img.classList.add("is-active");
        } else {
          img.classList.remove("is-active");
        }
      });

      // Update triggers
      this.triggers.forEach((trigger, i) => {
        if (i === index) {
          trigger.classList.add("is-active");
          trigger.setAttribute("aria-expanded", "true");
        } else {
          trigger.classList.remove("is-active");
          trigger.setAttribute("aria-expanded", "false");
        }
      });

      // Update panels
      this.panels.forEach((panel, i) => {
        if (i === index) {
          panel.classList.add("is-open");
          panel.hidden = false;
        } else {
          panel.classList.remove("is-open");
          panel.hidden = true;
        }
      });

      // Restart autoplay timer
      if (this.autoplay && !this.isPausing) {
        this.initAutoplay();
      }
    }

    initAutoplay() {
      clearTimeout(this.autoplayTimer);
      this.autoplayTimer = setTimeout(() => {
        this.openNextTab();
      }, this.autoplayDuration * 1000);
    }

    openNextTab() {
      const next = this.tabActiveIndex + 1 >= this.totalTabs ? 0 : this.tabActiveIndex + 1;
      this.openTab(next);
    }

    disconnectedCallback() {
      clearTimeout(this.autoplayTimer);
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define("lion-collection-tabs", CollectionTabs);
}
